__turbopack_context__.v({
  "airing_now": "Listing-module-scss-module__Z8FUpW__airing_now",
  "is_past": "Listing-module-scss-module__Z8FUpW__is_past",
  "listing": "Listing-module-scss-module__Z8FUpW__listing",
  "listing__details": "Listing-module-scss-module__Z8FUpW__listing__details",
  "listing__details__button": "Listing-module-scss-module__Z8FUpW__listing__details__button",
  "listing__duration": "Listing-module-scss-module__Z8FUpW__listing__duration",
  "listing__livestream_bug": "Listing-module-scss-module__Z8FUpW__listing__livestream_bug",
  "listing__modal_trigger": "Listing-module-scss-module__Z8FUpW__listing__modal_trigger",
  "listing__progress_bar": "Listing-module-scss-module__Z8FUpW__listing__progress_bar",
  "listing__show_title": "Listing-module-scss-module__Z8FUpW__listing__show_title",
  "listing__watch_btn__play_icon": "Listing-module-scss-module__Z8FUpW__listing__watch_btn__play_icon",
  "listing__watch_now": "Listing-module-scss-module__Z8FUpW__listing__watch_now",
  "selected_channel": "Listing-module-scss-module__Z8FUpW__selected_channel",
});
